/**
 * @description Employees Store Module
 * @author Fahid Mohammad
 */

const VueCookie = require('vue-cookie') // using require to avoid SSR rejection
import API from "../../services/api"

export default {
    namespaced: true,
    state: {
        gridData:{},
        userType:null,
        userTypeName:null,
        employeeId:null,
        searchQuery:{},
        commonUserModel:null,
        doctorModel:null,
        nurseModel:null,
        userData:{}
    },
    mutations:{
        SET_USER_DATA: (state, data) => {
            state.userData = data;
        },
        SET_GRID_DATA: (state, data) => {
            state.gridData = data;
        },
        SET_USER_TYPE_NAME: (state, data) => {
            state.userTypeName = data;
        },
        SET_USER_TYPE: (state, type) => {
            state.userType = type;
        },
        SET_EDIT_ID: (state, data) => {
            state.employeeId = data;
        },
        SET_COMMON_USER_MODEL: (state, data) => {
            state.commonUserModel = data;
        },
        SET_DOCTOR_MODEL: (state, data) => {
            state.doctorModel = data;
        },
        SET_NURSE_MODEL: (state, data) => {
            state.nurseModel = data;
        },
    },
    actions:{
        SET_USER_DATA({commit}, data) {
            commit('SET_USER_DATA', data)
        },
        SET_GRID_DATA({ commit }, data) {
            commit('SET_GRID_DATA', data)
        },
        SET_USER_TYPE({ commit }, type) {
            commit('SET_USER_TYPE', type)
        },
        SET_USER_TYPE_NAME({ commit }, type) {
            commit('SET_USER_TYPE_NAME', type)
        },
        SET_EDIT_ID({ commit }, modalData) {
            commit('SET_EDIT_ID', modalData)
        },
        SET_COMMON_USER_MODEL({ commit }, modalData) {
            commit('SET_COMMON_USER_MODEL', modalData)
        },
        SET_DOCTOR_MODEL({ commit }, modalData) {
            commit('SET_DOCTOR_MODEL', modalData)
        },
        SET_NURSE_MODEL({ commit }, modalData) {
            commit('SET_NURSE_MODEL', modalData)
        },
        SAVE_EMPLOYEE({commit}, modalData) {
            http.post(API_URL + '/hms/employee/add', requestData).then(response => {
               return callback(response)
            })
        },
    },
    getters:{
        userData: state => { return state.userData },
        gridData: state => { return state.gridData },
        userType: state => { return state.userType },
        userTypeName: state => { return state.userTypeName },
        employeeId: state => { return state.employeeId },
        commonUserModel: state => { return state.commonUserModel },
        doctorModel: state => { return state.doctorModel },
        nurseModel: state => { return state.nurseModel },
    }
}
    



// WEBPACK FOOTER //
// ./src/store/modules/employees.js